export const DevURL = `https://apiv2.rampnalysis.com/api/`;
// export const DevURL = "http://localhost:3005/api/";

export const LEADER_BOARD = "leader_board";

export const URL = DevURL;
